import Style from 'ol/style/Style';
import Text from 'ol/style/Text';
import Circle from 'ol/style/Circle';
import Fill from 'ol/style/Fill';
import Stroke from 'ol/style/Stroke';
import { createArrowHeadGeometry } from './geometry';

const primaryPointStylesByName = new Map();
const referencedPointStylesByName = new Map();
const routeStylesByLabel = new Map();

const sharedConnectionActiveStyle = new Style({
  stroke: new Stroke({
    color: 'orange',
    width: 2,
    lineDash: [5, 5]
  })
});

const sharedRouteArrowStyle = new Style({
  geometry: (feature) => createArrowHeadGeometry(feature.get('arrowCoord'), feature.get('arrowAngle')),
  fill: new Fill({ color: 'dodgerblue' }),
  stroke: new Stroke({ color: '#0e4f8f', width: 1 })
});

export { sharedConnectionActiveStyle, sharedRouteArrowStyle, primaryPointStylesByName, referencedPointStylesByName, routeStylesByLabel };

const isMobileViewport = window.matchMedia('(max-width: 900px)').matches;
const primaryPointRadius = isMobileViewport ? 9 : 5;
const referencedPointRadius = isMobileViewport ? 9 : 5;

export function getPrimaryPointStyle(name) {
  if (!primaryPointStylesByName.has(name)) {
    primaryPointStylesByName.set(name, new Style({
      image: new Circle({
        radius: primaryPointRadius,
        fill: new Fill({ color: 'cyan' }),
        stroke: new Stroke({ color: 'black', width: 2 })
      }),
      text: new Text({
        text: name,
        offsetY: -15,
        fill: new Fill({ color: 'black' }),
        stroke: new Stroke({ color: 'white', width: 2 })
      })
    }));
  }

  return primaryPointStylesByName.get(name);
}

export function getReferencedPointStyle(name, isHighlighted = false) {
  const color = isHighlighted ? 'red' : '#ffcccc'; // Light red by default, bright red when highlighted
  return new Style({
    image: new Circle({
      radius: referencedPointRadius,
      fill: new Fill({ color }),
      stroke: new Stroke({ color: 'black', width: 2 })
    }),
    text: new Text({
      text: name,
      offsetY: -15,
      fill: new Fill({ color: 'black' }),
      stroke: new Stroke({ color: 'white', width: 2 })
    })
  });
}

export function getRouteStyles(routeLabel) {
  const key = routeLabel || '';
  if (!routeStylesByLabel.has(key)) {
    routeStylesByLabel.set(key, [
      new Style({
        stroke: new Stroke({
          color: 'dodgerblue',
          width: 3,
          lineDash: [10, 5]
        }),
        text: new Text({
          text: key,
          placement: 'line',
          overflow: true,
          maxAngle: Math.PI / 6,
          font: '11px "Helvetica Neue", Helvetica, Arial, sans-serif',
          fill: new Fill({ color: '#1f2d3d' }),
          stroke: new Stroke({ color: '#ffffff', width: 3 })
        })
      }),
      sharedRouteArrowStyle
    ]);
  }

  return routeStylesByLabel.get(key);
}
